import React, {FC} from 'react';
import Image from 'next/image';

import {FORM_ADV_URL, FORM_CRS_URL, PRIVACY_POLICY_URL} from '../../constants';

import styles from './styles.module.scss';

const Disclaimer: FC = () => (
  <section className={styles.disclaimer}>
    <div className={styles.disclaimer__logoWrap}>
      <Image
        src="/static/img/zoe-logo/Zoe Logo White.svg"
        alt="Zoe Financial"
        width={85}
        height={24}
        className={styles.disclaimer__logo}
      />
    </div>
    <div className={styles.disclaimer__copy}>
      <p className={styles.disclaimer__body}>
        <strong className={styles.disclaimer__bodyStrong}>
          Important disclosures:{' '}
        </strong>
        This score is educational and based on the information you provided. It
        is not investment, financial, tax or legal advice is not a
        recommendation to buy or sell any security or to engage Zoe Financial or
        any advisor in its network. Score components and tier definitions are
        described in our methodology. See{' '}
        <a
          href={PRIVACY_POLICY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.disclaimer__link}>
          Privacy Policy
        </a>
        ,{' '}
        <a
          href={FORM_ADV_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.disclaimer__link}>
          Form ADV
        </a>
        , and{' '}
        <a
          href={FORM_CRS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.disclaimer__link}>
          Form CRS
        </a>
      </p>
      <p className={styles.disclaimer__body}>
        Zoe Financial, Inc. © {new Date().getFullYear()}
      </p>
    </div>
  </section>
);

export default Disclaimer;
